import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Box from 'fe-design-base/atoms/Box';
import Text from 'fe-design-base/atoms/Text';
import Dialog from 'fe-design-base/organisms/Dialog';

import { clickQuickbooksAuthUrl, closeQuickbooksAuthModal } from 'actions/ftu';

import {
  getShowQuickbooksAuthModal,
  getShowQuickbooksAuthUrl,
} from 'selectors/ftu';

import { toI18n } from 'util/i18n';

const QuickbooksAuthModal = () => {
  const dispatch = useDispatch();
  const isOpen = useSelector(getShowQuickbooksAuthModal);
  const quickbooksAuthUrl = useSelector(getShowQuickbooksAuthUrl);

  const handleClose = useCallback(() => {
    dispatch(closeQuickbooksAuthModal());
  }, [dispatch]);

  const handleQuickbooksAuthUrlClick = useCallback(() => {
    dispatch(clickQuickbooksAuthUrl());
  }, [dispatch]);

  return (
    <Dialog
      open={isOpen}
      title={toI18n('ftu.quickbooks.auth_modal.title')}
      onClose={handleClose}
      buttons={[
        {
          variant: 'primary',
          onClick: handleQuickbooksAuthUrlClick,
          href: quickbooksAuthUrl,
          label: toI18n('ftu.quickbooks.auth_modal.cta'),
        },
        {
          variant: 'tertiary',
          onClick: handleClose,
          label: toI18n('actions.cancel'),
        },
      ]}
    >
      {() => (
        <Box column maxw={500}>
          <Box hcenter row p={10}>
            <img
              src={require('theme/images/logos/quickbooks_x_homebase.png')}
            />
          </Box>

          <Box row p={10}>
            <Text
              variant="body"
              color="mono700"
              i18n="ftu.quickbooks.auth_modal.body"
            />
          </Box>
        </Box>
      )}
    </Dialog>
  );
};

export default QuickbooksAuthModal;
